import React from 'react';
import { get } from 'lodash';
import Box from '@material-ui/core/Box';
import { makeStyles, Typography } from '@material-ui/core';
import { LogoImage } from 'components/common';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },

  label: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}));

const NameField = (props) => {
  const classes = useStyles();

  const { record, imageSource, source } = props;

  const image = get(record, imageSource);
  const primary = get(record, source);

  return (
    <Box className={classes.root}>
      <LogoImage src={image} />

      <Box className={classes.label}>
        <Typography variant="body1" color="textPrimary">
          {primary}
        </Typography>
      </Box>
    </Box>
  );
};

export default NameField;
